import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between flex-col items-center px-2 h-full pt-[4.5rem] pb-36" }
const _hoisted_2 = { class: "leading-none text-center font-regular text-jm_white" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex flex-col items-center justify-center px-10" }
const _hoisted_5 = { class: "font-bold uppercase leading-none text-[2.1rem] mb-2 text-jm_white text-center" }
const _hoisted_6 = { class: "px-2 text-[1.1rem] leading-7 text-jm_white mb-2 text-center" }

import DefaultLayout from "../layouts/DefaultLayout.vue";
import logo from "@/assets/images/misc/logo_jaegermeister_white.svg";
import { useGlobalStore } from "../stores/global";
import { useGameTracking } from "@/composables/useGameTracking";


export default /*@__PURE__*/_defineComponent({
  __name: 'thatsEnough',
  setup(__props) {

const globalStore = useGlobalStore();
const { kpiTracker } = useGameTracking();

const handleEnoughClick = () => {
  globalStore.changeStep("ageCheck");
  globalStore.playTapSound();
  globalStore.setShouldShowDailyLimitScreen(false);
  globalStore.setCapturedPhotoFile(null);
  globalStore.setCapturedPhotoDataUrl(null);
  globalStore.setUploadedPhotoItemId(null);
  kpiTracker.resetGame();
  kpiTracker.resetTrackingData();
  globalStore.resetGame(kpiTracker.selectedPerson.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, { "background-image": "morePeople" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(logo),
            alt: "logo",
            class: "w-[100px]"
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("thats_enough.thats_enough")), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("thats_enough.thanks_for_playing")), 1),
          (_unref(globalStore).timesLeftToPlay === 0)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                onClick: handleEnoughClick,
                class: "flex items-center justify-center px-2 py-3 mt-4 text-sm font-bold rounded-lg cursor-pointer w-72 min-h-10 bg-jm_white"
              }, "GOT IT"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})